import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";
import AppConstants from "../constants/appConstants";

const ProfilePhotosApi = {
  fetchPhotos: async (page = 1, perPage = AppConstants.DEFAULT_PAGE_SIZE) => {
    try {
      const params = {
        page,
        per_page: perPage,
      };

      const response = await axiosInstance.get(Configs.profilePhotosEp, {
        params,
      });

      if (response.status === 200) {
        // console.log("Fetched photos:", response.data);
        return response.data || {};
      } else {
        console.error("Failed to load photos");
        return {};
      }
    } catch (error) {
      console.error("Error fetching photos:", error);
      return {};
    }
  },
};

export default ProfilePhotosApi;
